import {
    getGetTestingActivitiesPendingActivitiesQueryKey,
    GetTestingActivitiesPendingActivitiesQueryResult,
    useGetTestingActivitiesPendingActivities,
} from "api/generated/testing-activities/testing-activities";

export function getPendingTestingActivitiesQueryKey() {
    return getGetTestingActivitiesPendingActivitiesQueryKey();
}

const pendingTestingActivitiesQueryOptions = {
    select: (response: GetTestingActivitiesPendingActivitiesQueryResult) =>
        response.data,
};

interface PendingTestingActivitiesParams {
    enabled?: boolean;
}

export function usePendingTestingActivitiesQuery(
    params: PendingTestingActivitiesParams = {}
) {
    return useGetTestingActivitiesPendingActivities({
        query: {
            ...pendingTestingActivitiesQueryOptions,
            enabled: params.enabled ?? true,
        },
    });
}
